// Mixins
import AppPage from '../../mixins/app-page'

// Components
import AppButtonBook from '../app-button-book'
import AppCta from '../app-cta'
import AppScrollObject from '../app-scroll-object'

// Utils
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'
import { randomBetween } from '../../utils/Number'

export default
{
    name: 'page-home',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppButtonBook,
        AppCta,
        AppScrollObject
    },

    data()
    {
        return {
            _headerCTAIsHovered: false,
            _headerHovered: false
        }
    },

    computed:
    {
        content()
        {
            return this.$root.contentPage.page.acf
        },

        restaurants()
        {
            return this.$root.contentPage.restaurants
        },

        imagesOnHeader()
        {
            const images = []

            for (let i = 0; i < this.content.header_images.length; i += 1)
            {
                const image = this.content.header_images[i]
                image.parallaxRatio = randomBetween(0, 0.2)

                images.push(image)
            }

            return images
        },

        numberOfImagesOnHeader()
        {
            return this.content.header_images.length
        },

        numberOfEvenImagesOnHeader()
        {
            return Math.ceil(this.numberOfImagesOnHeader / 2)
        },

        numberOfOddImagesOnHeader()
        {
            return Math.floor(this.numberOfImagesOnHeader / 2)
        }
    },

    created()
    {
        console.log(this.restaurants)
        // Events
        this.eventHub.$on('window:resize', this._onResize)
        this.eventHub.$on('mouse:move', this._onMousemove)
        this.eventHub.$on('window:raf', this._onEnterFrame)

        // Variables
        this._headerFollowingTextRect = null
        this._headerCTARect = null
        this._restaurantsContainerRect = null

        this._mouseDistanceFromCTA = 0

        this._headerFollowingTextOffsets =
        {
            x: 10,
            y: 10
        }

        this._mouse =
        {
            x: 0,
            y: 0,
            event:
            {
                x: 0,
                y: 0
            },
            moved: false
        }
    },

    mounted()
    {
        // Events
        this.eventHub.$emit('page:medias-loaded')

        // Elements
        this.$headerFollowingText = this.$el.querySelector('.js-header-following-text')
        this.$headerCTA = this.$el.querySelector('.js-header-cta')
        this.$restaurantsContainer = this.$el.querySelector('.js-restaurants-container')
    },

    destroyed()
    {
        // Events
        this.eventHub.$off('window:resize', this._onResize)
        this.eventHub.$off('mouse:move', this._onMousemove)
        this.eventHub.$off('window:raf', this._onEnterFrame)
    },

    methods:
    {
        // Events
        _onResize()
        {
            if (this.$headerFollowingText)
            {
                this._headerFollowingTextRect = getAbsoluteBoundingRect(this.$headerFollowingText)
            }

            if (this.$headerCTA)
            {
                this._headerCTARect = getAbsoluteBoundingRect(this.$headerCTA)
            }

            if (this.$restaurantsContainer)
            {
                this._restaurantsContainerRect = getAbsoluteBoundingRect(this.$restaurantsContainer)
            }
        },

        _onMousemove(mouse)
        {
            if (!this._mouse.moved)
            {
                this._mouse.moved = true
            }

            this._mouse.event.x = mouse.x + this._headerFollowingTextOffsets.x
            this._mouse.event.y = mouse.y + this._headerFollowingTextOffsets.y
        },

        _onEnterFrame()
        {
            this._mouse.x += (this._mouse.event.x - this._mouse.x) * 0.1
            this._mouse.x = Math.round(this._mouse.x * 100) / 100

            this._mouse.y += ((this._mouse.event.y + this.$root.smoothScroll) - this._mouse.y) * 0.1
            this._mouse.y = Math.round(this._mouse.y * 100) / 100

            if (this.$headerFollowingText)
            {
                const translateX = Math.min(this._mouse.x, this.$root.width - this._headerFollowingTextRect.width)
                const translateY = Math.min(this._mouse.y, this.$root.height - this._headerFollowingTextRect.height)
                this.$headerFollowingText.style.transform = `translateX(${translateX}px) translateY(${translateY}px) translateZ(0)`
            }

            if (this._headerCTARect)
            {
                if (this._headerCTAIsHovered)
                {
                    this._mouseDistanceFromCTA = 0
                }
                else
                {
                    const dx = Math.max(Math.abs(this._headerCTARect.left - this._mouse.x), 0, Math.abs(this._mouse.x - this._headerCTARect.left + this._headerCTARect.width))
                    const dy = Math.max(Math.abs(this._headerCTARect.top - this._mouse.y), 0, Math.abs(this._mouse.y - this._headerCTARect.top + this._headerCTARect.height))

                    this._mouseDistanceFromCTA = Math.min(dx, dy)
                }

                if (this.$headerFollowingText)
                {
                    this.$headerFollowingText.style.opacity = this._mouseDistanceFromCTA < 100 || !this._headerHovered ? 0 : 1
                }
            }
        },

        // HTML Actions
        _onClickOnDiscoverRestaurant()
        {
            let value = this.$root.height

            if (this.$root.width > this.$root.CONSTANTS.breakpoints.xxs
                && this._restaurantsContainerRect)
            {
                value = this._restaurantsContainerRect.top + (this._restaurantsContainerRect.paddings.top / 2) + (122 /* .c-header height */ / 2)
            }
            else if (this.$root.width <= this.$root.CONSTANTS.breakpoints.xxs
                && this._restaurantsContainerRect)
            {
                value = this._restaurantsContainerRect.top + (this._restaurantsContainerRect.paddings.top / 2)
            }

            this.$root.scrollTo(value)
        },

        _onMouseenterHeader()
        {
            this._headerHovered = true
        },

        _onMouseleaveHeader()
        {
            this._headerHovered = false
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-home/script.js